import { render } from "./ButtonInput.vue?vue&type=template&id=b90b50e6&lang=pug"
import script from "./ButtonInput.vue?vue&type=script&lang=ts"
export * from "./ButtonInput.vue?vue&type=script&lang=ts"
script.render = render

export default script